import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  styled,
} from '@mui/material';
import { ValidationTextFieldColor } from 'src/utils/theme';

export const Wrapper = styled(FormControl)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SelectBox = styled(Select)<{ status?: string; $skinny?: boolean }>`
  width: 100%;
  border-style: solid;
  border-width: ${({ $skinny }: { $skinny?: boolean }) =>
    $skinny ? '0.15rem' : '0.05rem'};
  border-color: ${({ status }: { status?: string }) =>
    ValidationTextFieldColor(status)};
  border-radius: 0.25rem;

  & .MuiSelect-select {
    padding: ${({ $skinny }: { $skinny?: boolean }) =>
      $skinny ? '0.5rem 1rem' : '1rem 0.875rem'};
  }
`;

export const SelectBoxMenuItem = styled(MenuItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .MuiOutlinedInput-root fieldset {
    border-color: ${({ status }: { status?: string }) =>
      ValidationTextFieldColor(status)};
  }

  & fieldset {
    border: none;
  }

  & div {
    overflow: hidden;
  }
`;

export const SelectBoxMenuItemText = styled('p')`
  margin: 0;
`;

export const HoverIconButton = styled(IconButton)(
  () => `
    display: none;
    width: 15px;
    height: 15px;
    padding: 0;
    ${SelectBoxMenuItem}:hover & {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .MuiSvgIcon-root {
    font-size: 16px;
    margin: 0;
  }
    `,
);

export const StyledInputLabel = styled(InputLabel)(
  ({ theme, $hasLabel, shrink, $skinny }) => `
    display: flex;
    flex-direction: column;
    color: ${theme.palette.secondary.light};
    margin-top: ${$hasLabel ? ($skinny ? '24px' : '32px') : '5px'};
    font-size: ${shrink ? '0px' : '16px'}; 
  `,
);

export const StyledInputLabelText = styled('p')<{ $width?: number | null }>`
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${({ $width }: { $width?: number | null }) =>
    $width ? `${$width}px` : 'fit-content '};
`;

export const DropdownFooterButton = styled(Button)(
  ({ theme }) => `
  height: 50px;
  position: sticky;
  bottom: 0;
  border-radius: 0;
  border-top: 1px solid;
  border-color: ${theme.palette.divider};
  justify-content: start;
  padding-left: 16px;
  background-color: ${theme.palette.background.paper};

  &:hover {
    background-color: ${theme.palette.background.paper};
  }
`,
);
